import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import MockupUploadBanner from './MockupUploadBanner';
import { dismissMockupBanner, clearMockupUpload, selectMockupUpload } from '../../ducks/mockupUpload.duck';
import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { clearRequest, clearResult, clearListingContext } from '../../util/mockup-manager';

const mapStateToProps = state => {
  const mockupUpload = selectMockupUpload(state);

  return {
    isUploading: mockupUpload.isUploading,
    progressStatus: mockupUpload.progressStatus,
    error: mockupUpload.error,
    listingContext: mockupUpload.listingContext,
    currentJobId: mockupUpload.currentJobId,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onViewListing: (onDismissHandler) => {
    const { listingContext } = ownProps;
    const { history, routeConfiguration } = ownProps;

    if (listingContext) {
      const path = createResourceLocatorString(
        'ListingPage',
        routeConfiguration,
        {
          id: listingContext.listingId,
          slug: listingContext.listingSlug
        },
        {}
      );
      history.push(path);
    }

    // Dismiss after navigating (use the handler which will properly handle failed state)
    if (onDismissHandler) {
      onDismissHandler();
    } else {
      // Fallback to simple dismiss for completed uploads
      dispatch(dismissMockupBanner());
    }
  },

  onDismiss: (progressStatus, currentJobId) => {
    // If upload failed, clear all state (Redux + localStorage)
    if (progressStatus === 'failed' && currentJobId) {
      // Clear localStorage data for this job
      clearRequest(currentJobId);
      clearResult();
      clearListingContext(currentJobId);
      // Clear Redux state completely
      dispatch(clearMockupUpload());
    } else {
      // For completed uploads, just dismiss the banner
      dispatch(dismissMockupBanner());
    }
  },
});

// Need to merge state props with dispatch props to pass listingContext to onViewListing
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { listingContext, progressStatus, currentJobId } = stateProps;
  const onDismissHandler = () => dispatchProps.onDismiss(progressStatus, currentJobId);

  return {
    ...stateProps,
    ...ownProps,
    onViewListing: () => {
      const { history, routeConfiguration } = ownProps;

      if (listingContext) {
        const path = createResourceLocatorString(
          'ListingPage',
          routeConfiguration,
          {
            id: listingContext.listingId,
            slug: listingContext.listingSlug
          },
          {}
        );
        history.push(path);
      }

      // Dismiss after navigating (use the handler which will properly handle failed state)
      dispatchProps.onViewListing(onDismissHandler);
    },
    onDismiss: onDismissHandler,
  };
};

const ConnectedMockupUploadBanner = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )
)(MockupUploadBanner);

// Wrapper component that provides routeConfiguration via hook
const MockupUploadBannerContainer = (props) => {
  const routeConfiguration = useRouteConfiguration();
  return <ConnectedMockupUploadBanner {...props} routeConfiguration={routeConfiguration} />;
};

export default MockupUploadBannerContainer;
